export default "__VITE_ASSET__CVhKDnR8__"